import {ModuleWithProviders, NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TorchAPIConfiguration, TorchAPIConfigurationParams} from '../../config/api.configuration';
import {LoggingService} from '../../../app/shared/services/logging.service';

@NgModule({
  imports: [
    CommonModule,
  ],
})
export class TorchMiscModule {
  constructor(@Optional() @SkipSelf() parentModule: TorchMiscModule, private logger: LoggingService) {
    if (parentModule) {
      throw new Error('TorchMiscModule is already loaded. Import in your base AppModule only.');
    }

    logger.log('Loaded TorchMiscModule');
  }

  static forRoot(params: TorchAPIConfigurationParams): ModuleWithProviders<unknown> {
    return {
      ngModule: TorchMiscModule,
      providers: [
        {
          provide: TorchAPIConfiguration,
          useValue: params
        },
      ]
    };
  }
}
